<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <el-form :label-position="labelPosition" :rules="rules" label-width="150px" :model="detailList">
        <el-form-item label="所属期次" prop="period_id" class="all_width">
          <el-select v-model="detailList.period_id" filterable placeholder="请选择所属期次" >
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in periodArr" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级名称" prop="name">
          <el-input v-model="detailList.name" placeholder="请输入班级名称(年+zz+期次编号+班)"></el-input>
        </el-form-item>
        <el-form-item label="学员类型" prop="student_type" class="all_width">
          <el-select v-model="detailList.student_type" filterable placeholder="请选择学员类型" >
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in studentTypeArr" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="助教" prop="train_category" class="all_width">
          <el-select
            v-model="detailList.assistant"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择助教">
              <el-option
                v-for="item in assistantArr"
                :key="item.id"
                :label="item.realname"
                :value="item.id">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="培训地点" prop="province" class="location">
          <el-select v-model="detailList.province" filterable placeholder="请选择省" @change="changeProvince">
            <el-option :label="item.name" :value="item.code" v-for="(item,index) in province" :key="index"></el-option>
          </el-select>
          <el-select v-model="detailList.city" filterable placeholder="请选择市" @change="changeCity">
            <el-option :label="item.name" :value="item.code" v-for="(item,index) in citys" :key="index"></el-option>
          </el-select>
          <el-select v-model="detailList.area" filterable placeholder="请选择区">
            <el-option :label="item.name" :value="item.code" v-for="(item,index) in areas" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="detailList.address" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
        </el-form>  
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'editPeriod',
  components:{
  },
  data(){
    return {
      rules:{
        period_id :[{required: true, message: '请选择期次', trigger: 'change'}],
        name :[{required: true, message: '请输入班级名称', trigger: 'blur'}],
        student_type :[{required: true, message: '请选择学员类型', trigger: 'change'}],
      },
      labelPosition: 'right',
      citys:'',
      areas:'',
      periodArr:[],
      assistantArr:[],
      detailList:{},
    }
  },
  created(){
    this.id = this.$route.params && this.$route.params.id
    this.province = JSON.parse(this.$store.state.province) || JSON.parse(localStorage.getItem('province'))
    this.studentTypeArr = JSON.parse(this.$store.state.student_type) || JSON.parse(localStorage.getItem('student_type'))
    let inforParams = {
      group_id:this.id
    }
    this.getInfor(inforParams)
    // 获取期次
    let params = {
      period_name : '',
      category:''
    }
    this.obtainPeriod(params)
    // 获取助教
    let assistantparams = {
      realname :'',
      phone:''
    }
    this.obtainAssistant(assistantparams)
  },
  mounted(){

  },
  methods:{
    getInfor(params){
      this.$api.user.detailClass(params)
      .then(res=>{
        if(res.code === 0){
          this.detailList = res.result
          if(this.detailList.province){
            this.getProvince()
          }if(this.detailList.city){
              this.getCitys()
            }
        }
      }) 
    },
    obtainPeriod(params){
      this.$api.user.periodSelectList(params)
      .then(res=>{
        if(res.code === 0){
          this.periodArr = res.result
        }
      }) 
    },
    obtainAssistant(assistantparams){
      this.$api.user.assistantSelectList(assistantparams)
      .then(res=>{
          if(res.code === 0){
            this.assistantArr = res.result
          }
      }) 
    },
    //选择省
    getProvince(){
      let params = {
        code: this.detailList.province
      }
      this.$api.user.getCity(params)
        .then(res=>{
            if(res.code === 0){
              this.citys = res.result
            }
        }) 
    },
    changeProvince(){
      this.detailList.city = ''
      this.citys = []
      this.detailList.area = ''
      this.areas = []
      this.getProvince()
    },
    getCitys(){
      let params = {
        code: this.detailList.city
      }
      this.$api.user.getArea(params)
        .then(res=>{
            if(res.code === 0){
              this.areas = res.result
            }
        }) 
    },
    changeCity(){
        this.detailList.area = ''
        this.areas = []
      this.getCitys()
    },
    onSubmit(){
      var teachers = ''
      if(this.detailList.assistant.length>0){
          teachers = JSON.stringify(this.detailList.assistant)
      }else{
          teachers = ''
      }
      let params = {
        group_id:this.id,
        period_id: this.detailList.period_id, 
        name: this.detailList.name,
        student_type:this.detailList.student_type,
        province:this.detailList.province,
        city:this.detailList.city,
        area:this.detailList.area,
        address:this.detailList.address,
        assistant:teachers,
      }
      if(!this.detailList.period_id){
        this.$message.error('请选择期次')
      }else if(!this.detailList.name){
        this.$message.error('请输入班级名称')
      }else if(!this.detailList.student_type){
        this.$message.error('请选择学生类别')
      }else{
        this.$api.user.editClass(params)
          .then(res=>{
              if(res.code === 0){
                this.$message.success('编辑成功！')
                this.$router.replace({
                  path:'/class/class'
                })
              }
          }) 
      }
    },
  },
   computed: {
      
  }
}
</script>>
<style lang="scss" scoped>
  @import '../../assets/scss/content.scss';
  @import '../../assets/scss/editRotation.scss';
  @import '../../assets/scss/addOrganization.scss';
  @import '../../assets/scss/period.scss';
</style>
